/* ==========================================================================
   【57】スクロールで「ふわっと」表示させる（ルミエール独自）
   見た目（距離・時間）は assets/lumiere-custom-main.css の【57】。
   この JS は「いつ表示を始めるか」だけを決める（.scroll を付けると表示が始まる）。

   対象：.js-fadeBottom / .js-fadeTop / .js-fadeLeft / .js-fadeRight
   仕組み：layout/theme.liquid の <head> で <html> に .has-reveal を付けて先に隠しておき、
           画面に入ったものから .scroll を付けて表示する。

   2026-10-04 調整（参考：https://www.zushiya.com/ の出方）
   ・表示を始める位置を「画面の下端から 15% 入ったところ」にそろえた
     （以前はスクロール時の判定が画面の下端で先に表示してしまい、設定が効いていなかった）
   ・「読み込みから2.5秒後に画面の外も含めて全部表示」をやめた
     （下の方の要素はスクロールしたときには表示済みで、ふわっと出なかったため）。
     代わりに、すでに画面に入った・通り過ぎたものだけを表示する保険にした
   ========================================================================== */
(() => {
  const HTML = document.documentElement;
  HTML.classList.add('has-reveal');

  const SEL = '.js-fadeBottom,.js-fadeTop,.js-fadeLeft,.js-fadeRight';

  /* ===== 調整ポイント ===== */
  const START_RATIO = 0.85; // 要素の上端が画面の上から85%（＝下端から15%）まで来たら表示を始める

  const show = (el) => el.classList.add('scroll');

  /* 画面内で表示を始める位置まで来たもの・すでに通り過ぎたものを表示する */
  const sweep = (root = document) => {
    const vh = window.innerHeight || HTML.clientHeight;
    const atPageEnd = window.innerHeight + window.scrollY >= HTML.scrollHeight - 2;
    root.querySelectorAll(SEL).forEach((el) => {
      if (el.classList.contains('scroll')) return;
      const r = el.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return; // 非表示の要素（タブの中など）は見えたときに
      /* ページの一番下まで来たら、画面内に残っているものは全部出す（下端に届かない要素の救済） */
      if (r.top < vh * START_RATIO || r.bottom < 0 || (atPageEnd && r.top < vh)) show(el);
    });
  };

  let io = null;
  const init = (root = document) => {
    const nodes = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(show); // 古い環境では隠したままにならないよう全部出す
      return;
    }

    io ||= new IntersectionObserver(
      (entries, obs) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            show(e.target);
            obs.unobserve(e.target);
          }
        }
      },
      /* 画面の下 15% を判定から外す ＝ 下端から15%入ったら表示 */
      { root: null, rootMargin: `0px 0px -${Math.round((1 - START_RATIO) * 100)}% 0px`, threshold: 0 }
    );

    /* 読み込んだ時点で画面に入っているもの（ファーストビュー）は、透明な状態から順にふわっと出す */
    requestAnimationFrame(() => sweep(root));
    nodes.forEach((el) => {
      if (!el.classList.contains('scroll')) io.observe(el);
    });
  };

  // 起動
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => init(document), { once: true })
    : init(document);

  // 保険：IntersectionObserver が取りこぼしたもの（急なスクロール・ページ内リンクで飛んだ時など）
  let ticking = false;
  const onTick = () => {
    ticking = false;
    sweep(document);
  };
  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(onTick);
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);

  // 後から追加される要素（アプリ・遅延読み込み）。8秒だけ監視
  const mo = new MutationObserver((muts) => {
    for (const m of muts) for (const n of m.addedNodes) if (n.nodeType === 1) init(n);
  });
  mo.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => mo.disconnect(), 8000);

  // Shopify セクション（テーマエディタ）
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:section:reorder', (e) => init(e.target));

  // 読み込み完了後（画像でレイアウトがずれた後）にもう一度だけ確認
  window.addEventListener('load', () => setTimeout(() => sweep(document), 600));
})();
